module.exports = __webpack_public_path__ + "img/store-aachen.fda02c55.png";